import { useTranslation } from 'react-i18next'

import { Alert } from '@reveni-io/reveni-ui'

import PreviewSkeleton from './PreviewSkeleton/PreviewSkeleton'

const Preview = ({ preview, fetchingPreview, showAlert = true, iframeHeight = '350px' }) => {
  const { t } = useTranslation()

  if (fetchingPreview) {
    return <PreviewSkeleton iframeHeight={iframeHeight} showAlert={showAlert} />
  }

  return (
    <>
      {showAlert && (
        <Alert type="info">
          {t(
            'Estás viendo una vista previa de ejemplo. El contenido real cambiará según el contexto de la transacción.'
          )}
        </Alert>
      )}
      <iframe
        srcDoc={preview}
        style={{
          width: '100%',
          height: iframeHeight,
          border: 'none',
        }}
        title="Email Template Preview"
        sandbox="allow-same-origin"
      />
    </>
  )
}

export default Preview
